/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms

import io.kvision.*
import io.kvision.pace.Pace
import io.kvision.pace.PaceOptions
import io.kvision.panel.SimplePanel
import io.kvision.panel.StackPanel
import io.kvision.panel.root
import io.kvision.panel.stackPanel
import io.kvision.routing.Routing
import io.kvision.routing.routing
import io.kvision.utils.perc
import pl.finn.forms.wouip.WouipPanel
import pl.finn.forms.wouip.wouipRouting
import pl.finn.forms.sekap1794.Sekap1794Panel
import pl.finn.forms.sekap1794.sekap1794Routing
import pl.finn.forms.tw17.Tw17Panel
import pl.finn.forms.tw1.Tw1Panel
import pl.finn.forms.tw1.tw1Routing
import pl.finn.forms.tw17.tw17Routing
import pl.finn.forms.fk02.Fk02Panel
import pl.finn.forms.fk02.fk02Routing
import pl.finn.forms.podpp.PodppPanel
import pl.finn.forms.podpp.podppRouting
import pl.finn.forms.ezw.EzwPanel
import pl.finn.forms.ezw.ezwRouting
import pl.finn.forms.swz.SwzPanel
import pl.finn.forms.swz.swzRouting

class App : Application() {

  val SEKAP1794_INDEX = 1
  val TW1_5_INDEX = 1
  val TW1_7_INDEX = 1
  val FK_02_INDEX = 1
  val PODPP_INDEX = 1
  val WOUIP_INDEX = 1
  val EZW_INDEX = 1
  val SWZ_INDEX = 1

  private lateinit var rootStack: StackPanel

  override fun start(state: Map<String, Any>) {
    Routing.init()
    Pace.init(require("pace-progressbar/themes/blue/pace-theme-corner-indicator.css"))
    Pace.setOptions(PaceOptions(manual = true))
    root("kvapp") {
      width = 100.perc
      rootStack = stackPanel(false) {
        add(SimplePanel())
      }
      routing.tw1Routing(this@App)
      routing.tw17Routing(this@App)
      routing.sekap1794Routing(this@App)
      routing.fk02Routing(this@App)
      routing.podppRouting(this@App)
      routing.ezwRouting(this@App)
      routing.swzRouting(this@App)
      routing.wouipRouting(this@App)
      routing.resolve()
    }
  }

  fun aktywujtw1() {
    rootStack.activeIndex = TW1_5_INDEX
    rootStack.add(Tw1Panel())
  }

  fun aktywujtw17() {
    rootStack.activeIndex = TW1_7_INDEX
    rootStack.add(Tw17Panel())
  }
  fun aktywujSekap1794() {
    rootStack.activeIndex = SEKAP1794_INDEX
    rootStack.add(Sekap1794Panel())
  }
  fun aktywujFk02() {
    rootStack.activeIndex = FK_02_INDEX
    rootStack.add(Fk02Panel())
  }
  fun aktywujPodpp() {
    rootStack.activeIndex = PODPP_INDEX
    rootStack.add(PodppPanel())
  }
  fun aktywujWouip() {
    rootStack.activeIndex = WOUIP_INDEX
    rootStack.add(WouipPanel())
  }
  fun aktywujEzw() {
    rootStack.activeIndex = EZW_INDEX
    rootStack.add(EzwPanel())
  }

  fun aktywujSwz() {
    rootStack.activeIndex = SWZ_INDEX
    rootStack.add(SwzPanel())
  }
}

fun main() {
  startApplication(::App, module.hot, BootstrapModule, FontAwesomeModule, ImaskModule, TomSelectModule, CoreModule)
}
